import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/ecommerce/category-discounts/${resource.id}/edit`} />,
    <MenuItem primaryText='Category' key='category' value={`/ecommerce/categories/${resource.category_id}/edit`} />,
    <MenuItem primaryText='Discount' key='discount' value={`/ecommerce/discounts/${resource.discount_id}/edit`} />
  ]
}

export default buildMenuItems
